import { makeStyles } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    paddingBlock: '5px',
    paddingInline: '0px',
    marginBlock: '0px',
    flexWrap: 'wrap',
    listStyle: 'none',
    gap: theme.spacing(1),
  },
  chip: {
    backgroundColor: '#49B1F2',
    color: '#FFF',
    fontSize: 12,
    fontWeight: '600',
    minWidth: 75,
    paddingInline: 5,
    letterSpacing: 0.5,

    '& > span': {
      verticalAlign: 'middle',
    },

    '&:hover': {
      backgroundColor: 'currentColor',
    },
  },
  mensajeVacio: {
    marginBlock: theme.spacing(0.5),
  }
}));

export const ListItem = styled('li')(({ theme }) => ({
  marginBlock: theme.spacing(0.5),
}));

export default styles;
 